(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-announcement"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pb-announcement')) {
  customElements.define('pb-announcement', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const toggle = this.querySelector('.pb-ann-a-toggle');
      const panel = this.querySelector('.pb-ann-a-details');
      const setOpen = open => {
        toggle.setAttribute('aria-expanded', String(open));
        panel.hidden = !open;
      };
      toggle.addEventListener('click', () => setOpen(toggle.getAttribute('aria-expanded') !== 'true'));
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !panel.hidden) {
          setOpen(false);
          toggle.focus();
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-autumn-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-collection-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (!customElements.get("pb-collection-count")) {
    customElements.define("pb-collection-count", class extends HTMLElement {
      connectedCallback() {
        var _a;
        (_a = this.observer) == null ? void 0 : _a.disconnect();
        const main = this.closest("main");
        if (!main) return;
        const sync = () => {
          const source = main.querySelector('facets-form-component[data-collection-id="' + this.dataset.collectionId + '"][data-results-count]');
          if (!source) return;
          const count = Number(source.dataset.resultsCount);
          if (!Number.isFinite(count)) return;
          const text = this.dataset.template.replace("[count]", String(count));
          if (this.textContent !== text) this.textContent = text;
        };
        this.observer = new MutationObserver(sync);
        this.observer.observe(main, { childList: true, subtree: true, attributes: true, attributeFilter: ["data-results-count"] });
        sync();
      }
      disconnectedCallback() {
        var _a;
        (_a = this.observer) == null ? void 0 : _a.disconnect();
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-hot-sale"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pb-sale-carousel')) {
    customElements.define('pb-sale-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.track = this.querySelector('.pb-sale__track');
        this.previous = this.querySelector('[data-sale-prev]');
        this.next = this.querySelector('[data-sale-next]');
        this.controls = this.querySelector('.pb-sale__controls');
        if (!this.track) return;
        this.direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
        const update = () => {
          const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
          const position = Math.max(0, this.track.scrollLeft * this.direction);
          this.controls.hidden = maximum <= 4;
          this.previous.disabled = position <= 4;
          this.next.disabled = position >= maximum - 4;
        };
        const move = (direction) => {
          const card = this.track.querySelector('.pb-sale__item');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const distance = card.getBoundingClientRect().width + gap;
          this.track.scrollBy({left: direction * this.direction * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        };
        this.previous.addEventListener('click', () => move(-1), {signal});
        this.next.addEventListener('click', () => move(1), {signal});
        this.track.addEventListener('scroll', update, {signal, passive:true});
        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          move((event.key === 'ArrowRight' ? 1 : -1) * this.direction);
        }, {signal});
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(update);
          this.observer.observe(this.track);
        } else window.addEventListener('resize', update, {signal});
        update();
        this.startCountdown(signal);
      }
      updateDigit(digit, value) {
        const previous = digit.dataset.flipValue;
        if (previous === value) return;
        clearTimeout(digit.flipTimeout);
        digit.classList.remove('is-flipping');
        const valueNode = digit.querySelector('.pb-sale__flip-value');
        const top = digit.querySelector('.pb-sale__flip-top em');
        const bottom = digit.querySelector('.pb-sale__flip-bottom em');
        const foldTop = digit.querySelector('.pb-sale__flip-fold-top em');
        const foldBottom = digit.querySelector('.pb-sale__flip-fold-bottom em');
        digit.dataset.flipValue = value;
        valueNode.textContent = value;
        top.textContent = value;
        foldBottom.textContent = value;
        const finish = () => {
          bottom.textContent = value;
          foldTop.textContent = value;
          digit.classList.remove('is-flipping');
          digit.flipTimeout = null;
        };
        if (previous === undefined || document.hidden || matchMedia('(prefers-reduced-motion: reduce)').matches) {
          finish();
          return;
        }
        bottom.textContent = previous;
        foldTop.textContent = previous;
        void digit.offsetWidth;
        digit.classList.add('is-flipping');
        digit.flipTimeout = setTimeout(finish, 650);
      }
      startCountdown(signal) {
        const timer = this.querySelector('[data-sale-timer]');
        const rawStart = this.dataset.campaignStart;
        if (!timer || !rawStart) return;
        // A single absolute campaign window shared by all visitors, never restarted on reload.
        if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|[+-]\d{2}:\d{2})$/.test(rawStart)) return;
        const start = Date.parse(rawStart);
        if (!Number.isFinite(start)) return;
        const rawEnd = this.dataset.campaignEnd;
        if (rawEnd && !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|[+-]\d{2}:\d{2})$/.test(rawEnd)) { this.hidden = true; return; }
        const end = rawEnd ? Date.parse(rawEnd) : start + 72 * 60 * 60 * 1000;
        if (!Number.isFinite(end) || end <= start) { this.hidden = true; return; }
        const days = timer.querySelector('[data-sale-days]');
        const hours = timer.querySelector('[data-sale-hours]');
        const minutes = timer.querySelector('[data-sale-minutes]');
        const tick = () => {
          const now = Date.now();
          this.hidden = now < start || now >= end;
          timer.hidden = this.hidden;
          if (now >= end) { clearInterval(this.timerInterval); this.timerInterval = null; return; }
          if (now < start) return;
          const remaining = Math.ceil((end - now) / 1000);
          this.updateDigit(days, String(Math.floor(remaining / 86400)).padStart(2, '0'));
          this.updateDigit(hours, String(Math.floor(remaining / 3600) % 24).padStart(2, '0'));
          this.updateDigit(minutes, String(Math.floor(remaining / 60) % 60).padStart(2, '0'));
        };
        this.timerInterval = setInterval(tick, 1000);
        document.addEventListener('visibilitychange', tick, {signal});
        tick();
      }
      disconnectedCallback() {
        this.querySelectorAll('.pb-sale__digits b').forEach(digit => clearTimeout(digit.flipTimeout));
        clearInterval(this.timerInterval);
        this.timerInterval = null;
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (!customElements.get("pb-centered-reviews")) {
    customElements.define("pb-centered-reviews", class extends HTMLElement {
      connectedCallback() {
        var _a;
        (_a = this.controller) == null ? void 0 : _a.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.items = [...this.querySelectorAll("[data-review-id]")];
        this.buttons = [...this.querySelectorAll("[data-review-index]")];
        this.show = (index) => {
          this.items.forEach((item, i) => {
            item.hidden = i !== index;
            item.style.marginTop = "0";
          });
          this.buttons.forEach((button, i) => button.setAttribute("aria-pressed", String(i === index)));
        };
        this.buttons.forEach((button, i) => button.addEventListener("click", () => this.show(i), { signal }));
        this.addEventListener("shopify:block:select", (event) => {
          const index = this.items.findIndex((item) => item.dataset.reviewId === event.detail.blockId);
          if (index >= 0) this.show(index);
        }, { signal });
        const controls = this.querySelector(".pb-testimonial__controls");
        if (controls) controls.hidden = false;
        this.show(0);
      }
      disconnectedCallback() {
        var _a;
        (_a = this.controller) == null ? void 0 : _a.abort();
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
